import { render, staticRenderFns } from "./ModalServiceTax.vue?vue&type=template&id=331362c8&scoped=true"
import script from "./ModalServiceTax.vue?vue&type=script&lang=js"
export * from "./ModalServiceTax.vue?vue&type=script&lang=js"
import style0 from "./ModalServiceTax.vue?vue&type=style&index=0&id=331362c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331362c8",
  null
  
)

export default component.exports